import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box, Container, TextField, Typography } from "@material-ui/core";
import "../AdminCommonPages.css";
import axios from "axios";

const ProductType = ({ isShaws }) => {
  //   const classes = useStyles();
  const [productTypes, setProductTypes] = useState({
    productType: undefined,
  });
  const handleChange = (e) => {
    setProductTypes((prv) => ({
      ...prv,
      [e.target.id]: e.target.value,
    }));
  };
  const notify = () => {
    toast.success("Successfully Added !", {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        "https://abc-backend.onrender.com/api/products/product",
        productTypes
      );
      if (productTypes) {
        notify();
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={"type_main"}>
      <Container>
        <Typography variant="h2">Add Product Type</Typography>
        <Box>
          <form noValidate autoComplete="off" className="type_form">
            <Box>
              <label htmlFor="">Product Type </label>
              <br />
              <br />
              <TextField
                variant="outlined"
                id="productType"
                onChange={handleChange}
              />
            </Box>
            <Box className="type_submit_btn">
              <button className="common-btn" onClick={handleClick}>
                Add
              </button>
            </Box>
          </form>
        </Box>
        <ToastContainer
        //   position="top-right"
        //   autoClose={2000}
        //   hideProgressBar={false}
        //   newestOnTop={false}
        //   closeOnClick
        //   rtl={false}
        //   pauseOnFocusLoss
        //   draggable
        //   pauseOnHover
        //   theme="light"
        />
        {/* Same as */}
      </Container>
    </div>
  );
};

export default ProductType;
